/**
 * Checks whether a `value` is a string or not.
 * @param {*} value The value to check
 * @returns {boolean} `true` if `value` is a string; `false`, otherwise.
 */
const isString = value => typeof value === 'string';

export default isString;
